import {
    //Dialog,
    // DialogTitle,
    DialogActions,
    //DialogContent,
    MenuItem,
    FormControl,
    Grid,
    Divider,
    Radio,
    RadioGroup,
    FormControlLabel,
    TextField,
    Avatar,
    ListItemAvatar,
    Stack,
    Drawer

} from '@mui/material';

//import BadgeStatus from '../../../BadgeStatus';
import { LoadingButton } from '@mui/lab';
import HeaderModal from 'src/components/modal/HeaderModal';
import { SelectZui } from 'src/components/zui';
import { SelectItem } from 'src/@/components/ui/select';
import { Checkbox } from 'src/@/components/ui/checkbox';
import { useEffect, useState } from 'react';
import { Switch } from 'src/@/components/ui/switch';
import { Button } from "src/@/components/ui/button"
import { Input } from "src/@/components/ui/input"
import { Label } from "src/@/components/ui/label"
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "src/@/components/ui/popover"
import Iconify from 'src/components/Iconify';
import getActionListaUsuariosByClienteId from 'src/actions/usuarios/getActionListaUsuariosByClienteId';
import { ButtonLoading } from 'src/@/components/use/ButtonLoading';
import { useSnackbar } from 'notistack';
import v2_actionEditarLead from 'src/actions/v2/crm/v2_actionEditarLead';
import { RowInput } from 'src/components/forms/RowInput';

// ----------------------------------------------------------------------

export default function DrawerTransferirLead({ user, lead, onCallback }) {

    const [lista, setLista] = useState([]);
    const [isSendMessages, setIsSendMessages] = useState(true);
    const [selectedUser, setSelectedUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();



    async function buscarUsuarios() {
        console.log('buscando usuarios')
        try {
            const response = await getActionListaUsuariosByClienteId(user.clienteId);
            setLista(response.data.usuarios);
        } catch (error) {
            console.log('error', error)
        }
    }

    async function editarLead() {

        try {
            let data = {
                action: "transferir_usuario",
                scope: {
                    usuario_id: selectedUser,
                }
            }
            setLoading(true);
            await v2_actionEditarLead(lead._id, data, user.id);
            onCallback();
            setLoading(false)
            enqueueSnackbar('Usuário alterado com sucesso', { variant: 'success', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });
        } catch (error) {
            console.log('error', error)
            enqueueSnackbar('Erro ao transferir usuário', { variant: 'error', autoHideDuration: 3000, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } });

        }

    }


    useEffect(() => {
        buscarUsuarios();
        return () => {
            setLista([]);
            setSelectedUser(null);
        }
    }, []);




    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button variant="outline" className="h-8">
                    <Iconify icon="mingcute:transfer-line" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-80 z-[9999]">
            {!lead.closed ? (
                             <div className="flex flex-col gap-4">
                             <RowInput
                                 label={'Selecione o usuário'}
                                 input={
                                     <SelectZui
                                         value={selectedUser}
                                         list={lista}
                                         fullWidth
                                         onChange={event => {
                                             setSelectedUser(event);
                                         }}
                                         itemSelect={(item) => (
                                             <SelectItem key={item._id} value={item._id}>
                                                 {item.nomeFantasia}
                                             </SelectItem>
                                         )}
                                     />
                                 }
                             />
                             {selectedUser && (
                                 <ButtonLoading loading={loading} onClick={editarLead} disabled={!selectedUser} className={`${!selectedUser ? 'bg-slate-400' : 'bg-slate-700'} `}>
                                     {loading ? 'Transferindo...' : `${!selectedUser ? 'Selecione um usuário' : 'Transferir'}`}
                                 </ButtonLoading>
                             )}
                         </div>
                ) : (
                    <div className="flex flex-col gap-4">
                    <p className="text-[12px] [&:not(:first-child)]:mt-6">
                    <span className='font-bold'>Não é possível</span> transferir um lead finalizado. Reabra o lead para transferir.
                </p>
                </div>
                )}
                
            </PopoverContent>
        </Popover>
    )

}
